import React from 'react';
import {projects} from '../projectsData'
import Projects from '../Projects'
import '../Projects.css'

export default function Pages() {
  return (
    <>
      {
        projects.map((project, i) => {
          return (
            <Projects
            key={i}
            link={project.link}
            image={project.image}
            author={project.author}
            title={project.title}
            description={project.description}
            github={project.github}
            webLink={project['web-link']}
            />
          );
        })
      }
    </>
  );
}
